<form [formGroup]="regionFormGroup" (ngSubmit)="onRegionFormsSubmit()" class="needs-validation mt-1 form-row">
    <div class="col">
        <div class="form-group" [formGroup]="regionFormGroup">
            <label class="control-label col-form-label-sm">Region Name</label>
            <div class="input-group input-group-sm">
                <input type="text" class="form-control {{validationErrorsArray['name'] ? 'is-invalid' : ''}}" placeholder="Region Name" name="name" id="name" [required]="true" formControlName="name" />
                <div class="invalid-feedback">
                    {{validationErrorsArray['name'] | translate}}
                </div>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="form-group" [formGroup]="regionFormGroup">
            <label class="control-label col-form-label-sm">Countries Options</label>
            <select class="form-control form-control-sm {{validationErrorsArray['countryId'] ? 'is-invalid' : ''}}" name="countryId" id="countryId" [required]="true" formControlName="countryId">
                <option *ngFor="let country of countriesOptions" value="{{country.value}}">{{country.label}}</option>
            </select>
            <div class="invalid-feedback">
                {{validationErrorsArray['countryId'] | translate}}
            </div>
        </div>
    </div>
    <div class="col-auto text-right">
        <button type="submit" class="btn btn-primary btn-sm" style="margin-top: 27px;">Add location</button>
    </div>
</form>
